import { constants } from '@/constants/constants';
import {
  type CalendarProps,
  Calendar as PrimeCalendar,
} from 'primereact/calendar';
export const Calendar = ({ ...props }: CalendarProps) => {
  return (
    <PrimeCalendar
      showIcon
      dateFormat={constants.dateFormatUi}
      placeholder="eg: 11 Nov 2025"
      readOnlyInput
      showButtonBar
      {...props}
    />
  );
};
